module.exports = __webpack_public_path__ + "static/img/limit_07.e517071f.svg";